module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "frontmatter Prologue"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_107228-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  })]), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_107228-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('p', {
    staticClass: "title-num"
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/a9781847674562_tableofcontents"
    }
  }, [_c('span', {
    staticClass: "sc"
  }, [_vm._v("PROLOGUE")])])]), _vm._v(" "), _c('h1', [_c('a', {
    attrs: {
      "href": "#/a9781847674562_tableofcontents"
    }
  }, [_vm._v("A Foreign Office Romance")])])]), _vm._v(" "), _c('div', {
    staticClass: "block epigraph",
    attrs: {
      "id": "rw-block-epigraph_107228-00001"
    }
  }, [_c('p', {
    staticClass: "fp"
  }, [_vm._v("Napoleon ‘was aware, after the fall of Cairo was reported, that the final English triumph was only a matter of time, and consequently ordered [Louis-Guillaume] Otto, the leading French negotiator, to hasten the signing of the preliminaries of peace with [Henry] Addington’s government ([William] Pitt had been induced to resign on 14 March, 1801). News of the surrender of Alexandria reached Paris several days before the tidings reached London, and on 1 October, 1801, the Preliminaries of Amiens were signed. By adroit manoeuvering the French Government had deprived Great Britain of the full advantage of their successful campaign in Egypt; the news reached Whitehall too late to influence the deliberation at the conference table’ (David G. Chandler, "), _c('i', [_vm._v("The Campaigns of Napoleon")]), _vm._v(" (New York, Macmillan Co., 1966), p. 303). Robert Banks Jenkinson, Addington’s Foreign Secretary, did not become Baron Hawkesbury until 1803; as second Earl of Liverpool he was Prime Minister from 1812 to 1827, the longest continuous term in the last 250 years. ")])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-fp_107228-00001"
    }
  }, [_vm._v("There are many folk who knew Alphonse Lacour in his old age. From about the time of the Revolution of’48 until he died in the second year of the Crimean War he was always to be found in the same corner of the Café de Provence, at the end of the Rue St Honoré, coming down about nine in the evening, and going when he could find no one to talk with. It took some self-restraint to listen to the old diplomatist, for his stories were beyond all belief, and yet he was quick at detecting the shadow of a smile or the slightest little raising of the eyebrows. Then his huge, rounded back would straighten itself, his bulldog chin would project, and his r’s would burr like a kettle-drum. When he got as far as ‘Ah, monsieur r-r-r-rit!’ or ‘Vous ne "), _c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("me cr-r-r-royez pas donc!’ it was quite time to remember that you had a ticket for the opera.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("There was his story of Talleyrand and the five oyster-shells, and there was his utterly absurd account of Napoleon’s second visit to Ajaccio. Then there was that most circumstantial romance (which he never ventured upon until his second bottle had been uncorked) of the Emperor’s escape from St Helena−how he lived for a whole year in Philadelphia, while Count Herbert de Bertrand, who was his living image, personated him at Longwood. But of all his stories there was none which was more notorious than that of the Koran and the Foreign Office messenger. And yet when Monsieur Otto’s memoirs were written it was found that there really was some foundation for old Lacour’s incredible statement.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00003"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_2"
    }
  }, [_vm._v("‘You must know, monsieur,’ he would say, ‘that I left Egypt after Kleber’s assassination. I would gladly have stayed on, for I was engaged in a translation of the Koran, and between ourselves I had thoughts at the time of embracing Mahometanism, for I was deeply struck by the wisdom of their views about marriage. They had made an incredible mistake, however, upon the subject of wine, and this was what the Mufti who attempted to convert me could never get over. Then when old Kleber died and Menou came to the top, I felt that it was time for me to go. It is not for me to speak of my own capacities, monsieur, but you will readily understand that the man does not care to be ridden by the mule. I carried my Koran and my papers to London, where Monsieur Otto had been sent by the first Consul to arrange a treaty of peace; for both nations were very weary of the war, which had already lasted ten years. Here I was most useful to Monsieur Otto on account of my knowledge of the English tongue, and also, if I may say so, on account of my natural capacity. They were happy days during which I lived in the Square of Bloomsbury. The climate of monsieur’s country is, it must be confessed, detestable. But then what would you have? Flowers grow best in the rain. One has but to point to monsieur’s fellow-countrywomen to prove it.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00005"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("‘Well, Monsieur Otto, our Ambassador, was kept terribly busy over that treaty, and all of his staff were worked to death. We had not Pitt to deal with, which was perhaps as well for us. He was a terrible man that Pitt, and wherever half a dozen enemies of France were plotting together, there was his sharp-pointed nose right in the middle of them. The nation, however, had been thoughtful enough to put him out of office, and we had to do with Monsieur Addington. But Milord Hawkesbury was the Foreign Minister, and it was with him that we were obliged to do our bargaining.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00006"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("‘You can understand that it was no child’s play. After ten years of war each nation had got hold of a great deal which had belonged to the other, or to the other’s allies. What was to be given back? And what was to be kept? Is this island worth that peninsula? If we do this at Venice, will you do that at Sierra Leone? If we give up Egypt to the Sultan, will you restore the Cape of Good Hope, which you have taken from our allies the Dutch. So we wrangled and wrestled; and I have seen Monsieur Otto come back to the Embassy so exhausted that his secretary and I had to help him from his carriage to his sofa. But at last things adjusted themselves, and the night came round when the treaty was to be finally signed.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00007"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_3"
    }
  }, [_vm._v("‘Now you must know that the one great card which we held, and which we played, played, played at every point of the game, was that we had Egypt. The English were very nervous about our being there. It gave us a foot on each end of the Mediterranean, you see. And they were not sure that that wonderful little Napoleon of ours might not make it the base of an advance against India. So whenever Lord Hawkesbury proposed to retain anything, we had only to reply, ‘In "), _c('i', [_vm._v("that")]), _vm._v(" case, of course, we cannot consent to evacuate Egypt,’ and in this way we quickly brought him to reason. It was by the help of Egypt that we gained terms which were remarkably favourable, and especially that we caused the English to consent to give up the Cape of Good Hope; we did not wish your people, monsieur, to have any foothold in South Africa, for history has taught us that the British foothold of one half-century is the British Empire ")]), _c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("of the next. It is not your army or your navy against which we have to guard, but it is your terrible younger son and your man in search of a career. When we French have a possession across the seas, we like to sit in Paris and to felicitate ourselves upon it. With you it is different. You take your wives and your children, and you run away to see what kind of place this may be, and after that we might as well try to take that old Square of Bloomsbury away from you.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00008"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘Well, it was upon the first of October that the treaty was finally to be signed. In the morning I was congratulating Monsieur Otto upon the happy conclusion of his labours. He was a little pale shrimp of a man, very quick and nervous, and he was so delighted now at his own success that he could not sit still, but ran about the room chattering and laughing, while I sat on a cushion in the corner, as I had learned to do in the East. Suddenly, in came a messenger with a letter which had been forwarded from Paris. Monsieur Otto cast his eyes upon it, and then, without a word, his knees gave way, and he fell senseless upon the floor. I ran to him, as did the courier, and between us we carried him to the sofa. He might have been dead from his appearance, but I could still feel his heart thrilling beneath my palm.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00009"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘“What is this, then?” I asked.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00010"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘“I do not know,” answered the messenger. ‘Monsieur Talleyrand told me to hurry as never man hurried before, and to put this letter into the hands of Monsieur Otto. I was in Paris at midday yesterday.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00011"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_4"
    }
  }, [_vm._v("‘I know that I am to blame, but I could not help glancing at the letter, picking it out of the senseless hand of Monsieur Otto. My God! the thunderbolt that it was! I did not faint, but I sat down beside my chief and I burst into tears. It was but a few words, but they told us that Egypt had been evacuated by our troops a month before. All our treaty was undone then, and the one consideration which had induced our enemies to give us good terms had vanished. In twelve hours it would not have mattered. But now the treaty was not yet signed. We should have to give up the Cape. We should have to let ")]), _c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("England have Malta. Now that Egypt was gone we had nothing to offer in exchange.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00012"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘But we are not so easily beaten, we Frenchmen. You English misjudge us when you think that because we show emotions which you conceal, that we are therefore of a weak and womanly nature. You cannot read your histories and believe that. Monsieur Otto recovered his senses presently, and we took counsel what we should do.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00013"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘“It is useless to go on, Alphonse,” said he. “This Englishman will laugh at me when I ask him to sign.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00014"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘“Courage!” I cried; and then a sudden thought coming into my head− “How do we know that the English will have news of this? Perhaps they may sign the treaty before they know of it.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00015"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘Monsieur Otto sprang from the sofa and flung himself into my arms.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00016"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘“Alphonse,” he cried, “you have saved me! Why should they know about it? Our news has come from Toulon to Paris, and thence straight to London. Theirs will come by sea through the Straits of Gibraltar. At this moment it is unlikely that any one in Paris knows of it, save only Talleyrand and the first Consul. If we keep our secret, we may still get our treaty signed.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00017"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_5"
    }
  }, [_vm._v("‘Ah, monsieur, you can imagine the horrible uncertainty in which we spent the day. Never, never shall I forget those slow hours during which we sat together, starting at every distant shout, lest it should be the first sign of the rejoicing which this news would cause in London. Monsieur Otto passed from youth to age in a day. As for me, I find it easier to go out and meet danger than to wait for it. I set forth, therefore, towards evening. I wandered here, and wandered there. I was in the fencing-rooms of Monsieur Angelo, and in the salon-de-boxe of Monsieur Jackson, and in the club of Brooks, and in the lobby of the Chamber of Deputies, but nowhere did I hear any news. Still, it was possible that Milord Hawkesbury had received it himself just as we had. He lived in Harley Street, and there it was that the treaty was to be finally signed that night at eight. I entreated Monsieur Otto to drink two glasses of Burgundy before he went, for I feared lest his haggard ")]), _c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("face and trembling hands should rouse suspicion in the English minister.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00018"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘Well, we went round together in one of the Embassy’s carriages, about half-past seven. Monsieur Otto went in alone; but presently, on excuse of getting his portfolio, he came out again, with his cheeks flushed with joy, to tell me that all was well.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00019"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘“He knows nothing,” he whispered. “Ah, if the next half-hour were over!”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00020"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘“Give me a sign when it is settled,” said I.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00021"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘“For what reason?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00022"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘“Because until then no messenger shall interrupt you. I give you my promise−I, Alphonse Lacour.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00023"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘He clasped my hand in both of his. “I shall make an excuse to move one of the candles on to the table in the window,” said he, and hurried into the house, whilst I was left waiting beside the carriage.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00024"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘Well, if we could but secure ourselves from interruption for a single half-hour the day would be our own. I had hardly begun to form my plans when I saw the lights of a carriage coming swiftly from the direction of Oxford Street. Ah, if it should be the messenger! What could I do? I was prepared to kill him−yes, even to kill him, rather than at this last moment allow our work to be undone. Thousands die to make a glorious war. Why should not one die to make a glorious peace? What though they hurried me to the scaffold? I should have sacrificed myself for my country. I had a little curved Turkish knife strapped to my waist. My hand was on the hilt of it when the carriage which had alarmed me so rattled safely past me.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00025"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘But another might come. I must be prepared. Above all, I must not compromise the Embassy. I ordered our carriage to move on, and I engaged what you call a hackney coach. Then I spoke to the driver, and gave him a guinea. He understood that it was a special service.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00026"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘“You shall have another guinea if you do what you are told,” said I.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00027"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘“All right, master,” said he, turning his slow eyes upon me without a trace of excitement or curiosity.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00028"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_6"
    }
  }, [_vm._v("‘“If I enter your coach with another gentleman, you will ")]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("drive up and down Harley Street and take no orders from any one but me. When I get out, you will carry the other gentleman to Watier’s Club in Bruton Street.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00029"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘“All right, master,” said he again.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00030"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘So I stood outside Milord Hawkesbury’s house, and you can think how often my eyes went up to that window in the hope of seeing the candle twinkle in it. Five minutes passed, and another five. Oh, how slowly they crept along! It was a true October night, raw and cold, with a white fog crawling over the wet, shining cobblestones, and blurring the dim oil-lamps. I could not see fifty paces in either direction, but my ears were straining, straining, to catch the rattle of hoofs or the rumble of wheels. It is not a cheering place, monsieur, that Street of Harley, even upon a sunny day. The houses are solid and very respectable over yonder, but there is nothing of the feminine about them. It is a city to be inhabited by males. But on that raw night, amid the damp and the fog, with the anxiety gnawing at my heart, it seemed the saddest, weariest spot in the whole wide world. I paced up and down, slapping my hands to keep them warm, and still straining my ears. And then suddenly out of the dull hum of the traffic down in Oxford Street I heard a sound detach itself, and grow louder and louder, and clearer and clearer with every instant, until two yellow lights came flashing through the fog, and a light cabriolet whirled up to the door of the Foreign Minister. It had not stopped before a young fellow sprang out of it and hurried to the steps, while the driver turned his horse and rattled off into the fog once more.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00031"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘Ah, it is in the moment of action that I am best, monsieur. You, who only see me when I am drinking my wine in the Café de Provence, cannot conceive the heights to which I rise. At that moment, when I knew that the fruits of a ten-years’ war were at stake, I was magnificent. It was the last French campaign, and I the General and army in one.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00032"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘“Sir,” said I, touching him upon the arm, “are you the messenger for Lord Hawkesbury?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00033"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘“Yes,” said he.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00034"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }, [_vm._v("‘“I have been waiting for you half an hour,” said I. ")]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("“You are to follow me at once. He is with the French Ambassador.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00035"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘I spoke with such assurance that he never hesitated for an instant. When he entered the hackney coach and I followed him in, my heart gave such a thrill of joy that I could hardly keep from shouting aloud. He was a poor little creature, this Foreign Office messenger, not much bigger than Monsieur Otto, and I−monsieur can see my hands now, and imagine what they were like when I was seven-and-twenty years of age.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00036"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘Well, now that I had him in my coach, the question was what I should do with him. I did not wish to hurt him if I could help it.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00037"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘“This is a pressing business,’ said he. “I have a despatch which I must deliver instantly.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00038"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘Our coach had rattled down Harley Street, but now, in accordance with my instruction, it turned and began to go up again.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00039"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘“Hullo!” he cried. “What’s this?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00040"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘“What then?” I asked.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00041"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘“We are driving back. Where is Lord Hawkesbury?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00042"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘“We shall see him presently.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00043"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘“Let me out!” he shouted. “There’s some trickery in this. Coachman, stop the coach! Let me out, I say!”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00044"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘I dashed him back into his seat as he tried to turn the handle of the door. He roared for help. I clapped my palm across his mouth. He made his teeth meet through the side of it. I seized his own cravat and bound it over his lips. He still mumbled and gurgled, but the noise was covered by the rattle of our wheels. We were passing the minister’s house, and there was no candle in the window.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00045"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘The messenger sat quiet for a little, and I could see the glint of his eyes as he stared at me through the gloom. He was partly stunned, I think, by the force with which I had hurled him into his seat. And also he was pondering, perhaps, what he should do next. Presently he got his mouth partly free from the cravat.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00046"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  }, [_vm._v("‘“You can have my watch and my purse if you will let me go,” said he.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00048"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“Sir,” said I, “I am as honourable a man as you are yourself.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00049"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“Who are you, then?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00050"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“My name is of no importance.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00051"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“What do you want with me?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00052"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“It is a bet.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00053"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“A bet? What d’you mean? Do you understand that I am on the Government service, and that you will see the inside of a jail for this?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00054"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“That is the bet. That is the sport,” said I.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00055"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“You may find it poor sport before you finish,” he cried. “What is this insane bet of yours, then?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00056"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“I have bet,” I answered, “that I will recite a chapter of the Koran to the first gentleman whom I should meet in the street.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00057"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘I do not know what made me think of it, save that my translation was always running in my head.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00058"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("He clutched at the door-handle, and again I had to hurl him back into his seat.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00059"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“How long will it take?” he gasped.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00060"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“It depends on the chapter,” I answered.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00061"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“A short one, then, and let me go!”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00062"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“But is it fair?” I argued. “When I say a chapter I do not mean the shortest chapter, but rather one which should be of average length.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00063"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“Help! help! help!” he squealed, and I was compelled again to adjust his cravat.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00064"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“A little patience,” said I, “and it will soon be over. I should like to recite the chapter which would be of most interest to yourself. You will confess that I am trying to make things as pleasant as I can for you?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00065"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘He slipped his mouth free again.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00066"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“Quick, then, quick!” he groaned.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00067"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“The Chapter of the Camel?” I suggested.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00068"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“Yes, yes.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00069"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“Or that of the Fleet Stallion?”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00070"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘“Yes, yes. Only proceed!”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00071"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘We had passed the window and there was no candle. I settled down to recite the Chapter of the Stallion to him.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00072"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_9"
    }
  }, [_vm._v("‘Perhaps you do not know your Koran very well, ")]), _c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("monsieur? Well, I knew it by heart then, as I know it by heart now. The style is a little exasperating for any one who is in a hurry. But, then, what would you have? The people in the East are never in a hurry, and it was written for them. I repeated it all with the dignity and solemnity which a sacred book demands, and the young Englishman he wriggled and groaned.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00073"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("‘“When the horses, standing on three feet and placing the tip of their fourth foot upon the ground, were mustered in front of him in the evening, he said, “I have loved the love of earthly good above the remembrance of things on high, and have spent the time in viewing these horses. Bring the horses back to me.” And when they were brought back he began to cut off their legs and’−")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00074"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("‘It was at this moment that the young Englishman sprang at me. My God! how little can I remember of the next few minutes! He was a boxer, this shred of a man. He had been trained to strike. I tried to catch him by the hands. Pac, pac, he came upon my nose and upon my eye. I put down my head and thrust at him with it. Pac, he came from below. But ah! I was too much for him. I hurled myself upon him, and he had no place where he could escape from my weight. He fell flat upon the cushions, and I seated myself upon him with such conviction that the wind flew from him as from a burst bellows.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00075"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("‘Then I searched to see what there was with which I could tie him. I drew the strings from my shoes, and with one I secured his wrists, and with another his ankles. Then I tied the cravat round his mouth again, so that he could only lie and glare at me. When I had done all this, and had stopped the bleeding of my own nose, I looked out of the coach, and ah, monsieur, the very first thing which caught my eyes was that candle, that dear little candle, glimmering in the window of the minister. Alone, with these two hands, I had retrieved the capitulation of an army and the loss of a province. Yes, monsieur, what Abercrombie and five thousand men had done upon the beach at Aboukir was undone by me, single-handed, in a hackney coach in Harley Street.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00076"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_10"
    }
  }, [_vm._v("‘Well, I had no time to lose, for at any moment Monsieur ")]), _c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("Otto might be down. I shouted to my driver, gave him his second guinea, and allowed him to proceed to Watier’s. For myself, I sprang into our Embassy carriage, and a moment later the door of the minister opened. He had himself escorted Monsieur Otto downstairs, and now so deep was he in talk that he walked out bareheaded as far as the carriage. As he stood there by the open door, there came the rattle of wheels, and a man rushed down the pavement.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00077"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘“A despatch of great importance for Milord Hawkesbury!” he cried.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00078"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘I could see that it was not my messenger, but a second one. Milord Hawkesbury caught the paper from his hand, and read it by the light of the carriage lamp. His face, monsieur, was as white as this plate before he had finished.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00079"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘“Monsieur Otto,” he cried, “we have signed this treaty upon a false understanding. Egypt is in our hands.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00080"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘“What!” cried Monsieur Otto. “Impossible!”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00081"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘“It is certain. It fell to Abercrombie last month.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00082"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘“In that case,” said Monsieur Otto, “it is very fortunate that the treaty is signed.”")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00083"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘“Very fortunate for you, sir,” cried Milord Hawkesbury, and he turned back to the house.")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00084"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_11"
    }
  }, [_vm._v("‘Next day, monsieur, what they call the Bow Street runners were after me, but they could not run across salt water, and Alphonse Lacour was receiving the congratulations of Monsieur Talleyrand and the first Consul before ever his pursuers had got as far as Dover.’")])]), _c('p', {
    attrs: {
      "id": "rw-p_107228-00085"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_12"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36ae12ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/a9781847674562_prologue.vue
// module id = 72
// module chunks = 0